import Clinic from "pages/clinic/index.js";
import ClinicResetPassword from "pages/clinic_reset_password";
import Login from "pages/login/Login";
import TermsPolicy from "pages/terms-policy";
import { ROUTE } from "./route";
import DeleteAccount from "pages/delete_account";
import GraphComponent from "pages/graph";
import GraphComponentPublic from "pages/graph/graph-public";

const publicRoutes = [
  {
    path: ROUTE.PUBLIC.LOGIN,
    component: Login,
  },
  {
    path: ROUTE.PUBLIC.SIGN_UP,
    component: Clinic,
  },
  {
    path: ROUTE.PUBLIC.RESET_PASSWORD,
    component: ClinicResetPassword,
  },
  {
    path: ROUTE.PUBLIC.TERMS_POLICY,
    component: TermsPolicy,
  },
  {
    path: ROUTE.PUBLIC.DELETE_ACCOUNT,
    component: DeleteAccount,
  },
  {
    path: ROUTE.PUBLIC.GRAPH,
    component: GraphComponentPublic,
  }
];

export default publicRoutes;
